export function saveTokenToCookie(token) {
  if (token) {
    document.cookie = `token=${encodeURIComponent(token)}; path=/; max-age=31536000`;
  }
}

export function getTokenFromCookie() {
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.search
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    if (urlToken) {
      saveTokenToCookie(urlToken);
      // Clean up ?token= from URL bar without page refresh
      urlParams.delete('token');
      const newSearch = urlParams.toString() ? `?${urlParams.toString()}` : '';
      const newUrl = `${window.location.pathname}${newSearch}${window.location.hash}`;
      window.history.replaceState(null, '', newUrl);
      return urlToken;
    }
  }

  const name = 'token=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let cookie of cookieArray) {
    cookie = cookie.trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }

  return null;
}
